/* eslint-disable max-len */
import { useHubSwitch } from '@bpm-web-app/utils';

const supreme = {
    sections: [
        <div>
            <h2>How does BPM Supreme&nbsp;work?</h2>
            <ul>
                <li>Over 100 top record labels send their music to BPM Supreme, including all major labels</li>
                <li>Our pro audio team then craft DJ-ready versions, edits, and remixes you can’t find anywhere else</li>
                <li>Our subscribers can download these as HQ MP3s and keep them forever.</li>
            </ul>
        </div>,
        <div>
            <h2>What Your Subscription Includes</h2>
            <p>
                Every BPM Supreme subscription provides download access to our massive library of DJ-ready music across either Open Format or Latino+Global libraries. This includes exclusive content you wont
                find anywhere else; like DJ versions of popular tracks, remixes and edits, playlists, and more.
            </p>
        </div>,
        <div>
            <h2>What makes BPM Supreme&nbsp;unique?</h2>
            <p>
                BPM Supreme is the #1 source for DJ-ready music for 4 years running. It’s the industry standard music source for pro DJs, due to our unparalled audio team, industry-leading curation,
                and tailor made platform.
            </p>
        </div>,
    ],
    highlightedBlock: {
        title: 'Level Up Your DJ Game',
    },
};

const create = {
    sections: [
        <div>
            <h2>How does BPM Create&nbsp;work?</h2>
            <ul>
                <li>Library of over 1 million sounds, including sample packs, loops, one-shots, vocals, FX, instruments, and more.</li>
                <li>Simple sounds download in high-quality 24-bit WAV at 44.1kHz.</li>
                <li>Stay organized with custom drives and share ideas with collaborative drives.</li>
            </ul>
        </div>,
        <div>
            <h2>What Your Subscription Includes</h2>
            <p>
                Every BPM Create subscription provides access to our extensive library of music samples and loops, encompassing exclusive content such as unique sound packs, instrumentals, beats, and
                more, tailored for music production across various genres.
            </p>
        </div>,
        <div>
            <h2>What makes BPM Supreme&nbsp;unique?</h2>
            <p>
                BPM Create is the top choice for music producers, featuring an extensive selection of samples and loops, exceptional sound quality and a platform designed specifically for ease of use.
            </p>
        </div>,
    ],
    highlightedBlock: {
        title: 'Level Up Your Music Production Game',
    },
};

export const useSectionTexts = () => {
    const { isCreate } = useHubSwitch();
    return isCreate ? create : supreme;
};

/* eslint-enable max-len */
